import { useEffect, useState } from "react";
import { DEFAULT_CONFIG, fetchConfig, type AppConfig } from "./api";

const OFF: AppConfig = DEFAULT_CONFIG;

/** Feature flags from the server (subscriptions / referrals are off until the business switches them on). */
export function useConfig(): AppConfig {
  const [config, setConfig] = useState<AppConfig>(OFF);
  useEffect(() => {
    let alive = true;
    fetchConfig().then((c) => alive && setConfig(c));
    return () => {
      alive = false;
    };
  }, []);
  return config;
}
